/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

export const controls_ciclo = (block, generator) => {
  const cycle = block.getFieldValue('CYCLE');
  const duration = generator.valueToCode(block, 'TIMES', generator.ORDER_ASSIGNMENT);

  let branch = generator.statementToCode(block, 'DO');
  if (generator.INFINITE_LOOP_TRAP) {
    branch = `${generator.INFINITE_LOOP_TRAP.replace(/%1/g, `'${block.id}'`)}${branch}`;
  }

  generator.definitions_.controls_ciclo = `
long tiempoCiclo;
int ciclo;

void ejecutarCiclo(int duracion) {
  if (millis() > tiempoCiclo + duracion) {
    tiempoCiclo = millis();
    ciclo++;
    if (ciclo > 8) {
      ciclo = 1;
    }
  }
}
`;
  generator.setups_.controls_ciclo = '\nciclo = 1;\n';

  return `
if (ciclo == ${cycle}) {
  ejecutarCiclo(${duration});
  ${branch}
}
`;
};

const DISPLAY_7_SEGMENTS_DEF = `
byte numeros[] = {
  B1111101, //0
  B0110000, //1
  B1101110, //2
  B1111010, //3
  B0110011, //4
  B1011011, //5
  B1011111, //6
  B1110000, //7
  B1111111, //8
  B1110011, //9
};

int pinLed[] = {
  8, 7, 6, 5, 4, 3, 2
};

#define display1 9
#define display2 10

void escribir_en_el_display(int numero){
  int primerDigito = numero / 10;
  int segundoDigito = numero - primerDigito * 10;

  digitalWrite(display1, HIGH);
  digitalWrite(display2, LOW);
  prender(primerDigito);
  delay(10);

  digitalWrite(display2, HIGH);
  digitalWrite(display1, LOW);
  prender(segundoDigito);
  delay(10);
}

void prender(int cual) {
  for (int i = 0; i < 7; i++) {
    boolean prendido = bitRead (numeros[cual], i);
    digitalWrite(pinLed[i], prendido);
  }
}

void apagar_el_display(void) {
  digitalWrite(display1, LOW);
  digitalWrite(display2, LOW);
}
`;

const DISPLAY_7_SEGMENTS_SETUP = `
  for (int i = 0; i < 7; i++) {
    pinMode(pinLed[i], OUTPUT);
  }
  pinMode(display1, OUTPUT);
  pinMode(display2, OUTPUT);
`;

const installDisplay7Segments = (generator) => {
  generator.definitions_.display_7_segments = DISPLAY_7_SEGMENTS_DEF;
  generator.setups_.display_7_segments = DISPLAY_7_SEGMENTS_SETUP;
};

export const display_7_segments = (block, generator) => {
  const time = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || '';
  installDisplay7Segments(generator);
  return `\nescribir_en_el_display(${time});\n`;
};

export const display_7_segments_off = (block, generator) => {
  installDisplay7Segments(generator);
  return '\napagar_el_display();\n';
};

const installLuzPeaton = (generator) => {
  generator.definitions_.luz_peaton = `
#include <Adafruit_NeoPixel.h>
#define PINLEDS 13
#define NUMPIXELS 3

Adafruit_NeoPixel pixels(NUMPIXELS, PINLEDS, NEO_GRB + NEO_KHZ800);

void prenderLuzPeaton(int r, int g, int b) {
  for (int i = 0; i < NUMPIXELS; i++) {
    pixels.setPixelColor(i, pixels.Color(r, g, b));
  }
  pixels.show();
  delayMicroseconds(300);
}
`;
  generator.setups_.luz_peaton = 'pixels.begin();\npixels.setBrightness(30);\n';
  generator.loop_.luz_peaton = 'pixels.clear();';
};

export const luz_peaton = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  installLuzPeaton(generator);
  return `\nprenderLuzPeaton(${color});\n`;
};

export const luz_peaton_off = (block, generator) => {
  installLuzPeaton(generator);
  return '\nprenderLuzPeaton(0,0,0);\n';
};

export const math_counter = (block, generator) => {
  const timeCode = generator.valueToCode(block, 'NUM', generator.ORDER_ATOMIC);
  const time = timeCode > 0 ? timeCode : 1;
  const order = time < 0 ? generator.ORDER_UNARY_PREFIX : generator.ORDER_ATOMIC;
  const randName = block.id.replace(/[^a-zA-Z0-9]+/g, '');

  generator.definitions_[`math_counter_${randName}`] = `
int cuentaRegresiva_${randName}(int tiempoTotal){
  static int cuentaRegresiva = tiempoTotal;
  static long tiempoCuentaRegresiva = millis();

  if (millis() > tiempoCuentaRegresiva + 1000) {
    if (cuentaRegresiva > 0) {
      cuentaRegresiva--;
      tiempoCuentaRegresiva = millis();
    } else {
      cuentaRegresiva = tiempoTotal;
    }
  }
  return cuentaRegresiva;
}
`;

  return [`cuentaRegresiva_${randName}(${time})`, order];
};

export const math_number_minmax_7segments = (block, generator) => {
  const code = block.getFieldValue('SLIDER');
  return [code, generator.ORDER_ATOMIC];
};

export const semaforo = (block, generator) => {
  const estado = block.getFieldValue('STAT');
  const color = block.getFieldValue('COLOR');
  const calle = block.getFieldValue('CALLE');

  generator.definitions_.semaforo = `
#define rojo_0 14
#define amarillo_0 15
#define verde_0 16
#define rojo_1 17
#define amarillo_1 18
#define verde_1 19
`;
  generator.setups_.semaforo = `
for (int i = 14; i < 20; i++) {
  pinMode(i, OUTPUT);
}
`;

  return `\ndigitalWrite(${color}_${calle}, ${estado});\n`;
};

export const semaforo_giro = (block, generator) => {
  const estado = block.getFieldValue('STAT');
  const color = block.getFieldValue('COLOR');

  generator.definitions_.semaforo_2 = `
#define giro_rojo 11
#define giro_verde 12
`;
  generator.setups_.semaforo_2 = `
pinMode(giro_rojo, OUTPUT);
pinMode(giro_verde, OUTPUT);
`;

  return `\ndigitalWrite(giro_${color}, ${estado});\n`;
};
